// src/components/CommonProfileCard/ProfileSkeleton.js
import React from "react";
import Skeleton from "react-loading-skeleton";
import 'react-loading-skeleton/dist/skeleton.css';

const ProfileSkeleton = () => {
    return (
        <div className="profile-card">
            <div className="profile-img-wrapper">
                <Skeleton height={180} />
            </div>
            <div className="profile-details">
                <p><Skeleton width="60%" /></p>
                <p><Skeleton width="80%" /></p>
                <p><Skeleton width="50%" /></p>
                <p><Skeleton width="70%" /></p>
                <p><Skeleton width="40%" /></p>
                <div className="profile-footer" style={{ display: "flex", gap: "8px" }}>
                    <Skeleton height={35} width={80} />
                    <Skeleton height={35} width={90} />
                    <Skeleton height={35} width={100} />
                </div>
            </div>
        </div>
    );
};

export default ProfileSkeleton;
